var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 items row"},_vm._l((_vm.options),function(option){return _c('div',{key:option.id,staticClass:"col-12 col-lg-4 item",on:{"click":function($event){return _vm.selectOption(option)}}},[_vm._t("cardContent",function(){return [_vm._v(_vm._s(option))]},{"item":option})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }